import type { NegociacaoDetailTab } from '../types/negociacaoDetailTypes';

interface PedidoDaFilaInput {
  activeTab: NegociacaoDetailTab;
  casoId: string;
  /** O caso cuja fila já foi buscada — `null` enquanto nenhuma busca terminou. */
  casoIdBuscado: string | null;
  isLoading: boolean;
}

/**
 * Se a aba Chat deve disparar a busca da fila de telefones.
 *
 * A guarda é o caso JÁ BUSCADO, nunca `telefones.length > 0`: a fila vem vazia em todo caso
 * legado (e hoje, em produção, em todos), então contar itens nunca fecha a guarda e o
 * `isLoading` alternando true→false rearma o efeito — o que martelava
 * `GET /negociacao/casos/:id/telefones` a ~13 req/s enquanto a aba ficasse aberta. Falha também
 * conta como buscado: re-tentar em loop não conserta um 500.
 */
export const devePedirFilaDeTelefones = ({
  activeTab,
  casoId,
  casoIdBuscado,
  isLoading,
}: PedidoDaFilaInput): boolean => {
  if (activeTab !== 'chat' || isLoading) return false;
  return casoIdBuscado !== casoId;
};
